import { useRef, useState } from "react";
import { dropAtEnd, dropItem } from "@/helpers/showcaseOrder";

const useShowcaseDrag = () => {
  const [dragId, setDragId] = useState(null);
  const [overId, setOverId] = useState(null);
  const dragRef = useRef(null);

  const handlersFor = ({ items, mode, commit }) => {
    const finishDrop = (targetId, endOfGroup) => {
      const dragged = dragRef.current;
      dragRef.current = null;
      setDragId(null);
      setOverId(null);
      if (dragged === null || dragged === undefined) return;
      if (endOfGroup) commit(dropAtEnd(items, dragged, endOfGroup === "pinned", mode), true);
      else if (targetId !== null && targetId !== dragged) commit(dropItem(items, dragged, targetId, mode), true);
    };

    const targetAt = (x, y) => {
      const node = document.elementFromPoint(x, y);
      const row = node?.closest?.("[data-id]");
      if (row) return { id: Number(row.getAttribute("data-id")) };
      const group = node?.closest?.("[data-drop-group]");
      return group ? { group: group.getAttribute("data-drop-group") } : null;
    };

    const dragPropsOf = (item) => ({
      row: {
        draggable: true,
        onDragStart: (event) => {
          dragRef.current = item.wantAdId;
          setDragId(item.wantAdId);
          if (event.dataTransfer) {
            event.dataTransfer.effectAllowed = "move";
            event.dataTransfer.setData("text/plain", String(item.wantAdId));
          }
        },
        onDragOver: (event) => {
          if (dragRef.current === null) return;
          event.preventDefault();
          if (overId !== item.wantAdId) setOverId(item.wantAdId);
        },
        onDrop: (event) => {
          event.preventDefault();
          finishDrop(item.wantAdId);
        },
        onDragEnd: () => {
          dragRef.current = null;
          setDragId(null);
          setOverId(null);
        },
      },
      grip: {
        onPointerDown: (event) => {
          if (event.pointerType === "mouse") return;
          event.preventDefault();
          event.currentTarget.setPointerCapture?.(event.pointerId);
          dragRef.current = item.wantAdId;
          setDragId(item.wantAdId);
        },
        onPointerMove: (event) => {
          if (dragRef.current === null || event.pointerType === "mouse") return;
          const target = targetAt(event.clientX, event.clientY);
          setOverId(target?.id ?? null);
        },
        onPointerUp: (event) => {
          if (dragRef.current === null || event.pointerType === "mouse") return;
          const target = targetAt(event.clientX, event.clientY);
          finishDrop(target?.id ?? null, target?.group);
        },
        onPointerCancel: () => {
          dragRef.current = null;
          setDragId(null);
          setOverId(null);
        },
      },
    });

    const groupDrop = (group) => ({
      "data-drop-group": group,
      onDragOver: (event) => {
        if (dragRef.current !== null) event.preventDefault();
      },
      onDrop: (event) => {
        if (event.target.closest("[data-id]")) return;
        event.preventDefault();
        finishDrop(null, group);
      },
    });

    return { dragPropsOf, groupDrop };
  };

  return { dragId, overId, handlersFor };
};

export default useShowcaseDrag;
